module.exports = __webpack_public_path__ + "img/standard.274f649e.svg";